import classNames from 'classnames';
import fp from 'lodash/fp';
import PropTypes from 'prop-types';
import React from 'react';
import FormField from './form-field';

const InputFormField = ({
  children,
  formFieldProps,
  id,
  inputProps,
  inputTag: InputTag,
  inputType,
  onBlur,
  onChange,
  onKeyPress,
  required,
  validation,
  value,
  disabled,
  ...otherProps
}) => (
    <FormField {...{
      ...otherProps,
      ...formFieldProps,
      id,
      validation,
      input: (
        <InputTag {...{
          ...inputProps,
          id,
          name: fp.getOr(fp.camelCase(id))('name')(otherProps),
          type: inputType,
          className: classNames('form-control', { filled: value }),
          value,
          onChange,
          onBlur,
          onKeyPress,
          required,
          disabled,
          'aria-invalid': validation ? 'true' : 'false',
          // Check that there is actually a validation message, not just that we have an error
          'aria-describedby': validation && typeof validation === 'string' ?
            `${id}-help-block` :
            null
        }} />
      )
    }}>
      {children}
    </FormField>
  );

InputFormField.propTypes = {
  ...FormField.propTypes,
  formFieldProps: PropTypes.object,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  inputTag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  inputType: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onKeyPress: PropTypes.func,
  required: PropTypes.bool,
  validation: FormField.propTypes.validation,
  value: PropTypes.any
};

InputFormField.defaultProps = {
  inputTag: 'input',
  inputType: 'text'
};

export default InputFormField;



// WEBPACK FOOTER //
// ./src/containers/components/input-form-field.js